<template>
  <div class="tcard">
    <div class="avatar">
      <img v-if="trainer.photo_url" :src="trainer.photo_url" :alt="trainer.name" />
      <span v-else>{{ initials }}</span>
    </div>
    <div class="tbody">
      <b>{{ trainer.name }}</b>
      <span class="trole">{{ trainer.role }}</span>
      <p class="tbio">{{ trainer.bio }}</p>
      <div class="tcontact">
        <a v-if="trainer.email" class="chip" :href="'mailto:' + trainer.email">
          ✉ {{ trainer.email }}
        </a>
        <a v-if="trainer.phone" class="chip" :href="'tel:' + trainer.phone">
          ☎ {{ trainer.phone }}
        </a>
      </div>
      <button
        v-if="trainer.show_sue_cta"
        type="button"
        class="sue-btn"
        @click="$emit('sue')"
      >
        💬 Ask Sue — get instant answers
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerCard',
  props: {
    trainer: {
      type: Object,
      required: true
    }
  },
  computed: {
    initials () {
      return this.trainer.name
        .split(' ')
        .map((p) => p.charAt(0))
        .join('')
        .slice(0, 2)
        .toUpperCase()
    }
  }
}
</script>

<style scoped>
.tcard {
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 18px;
  background: var(--white);
  display: flex;
  gap: 14px;
  align-items: flex-start;
}
.avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  flex: 0 0 auto;
  background: linear-gradient(135deg, var(--berry), var(--coral));
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 800;
  font-size: 1.1rem;
  overflow: hidden;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tbody {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.tbody > b {
  font-size: 1.02rem;
}
.trole {
  font-size: 0.8rem;
  color: var(--teal-dk);
  font-weight: 600;
}
.tbio {
  font-size: 0.88rem;
  color: var(--ink-soft);
  margin: 4px 0 8px;
}
.tcontact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.chip {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--teal-dk);
  text-decoration: none;
  background: var(--paper);
  border: 1px solid var(--line);
  border-radius: 999px;
  padding: 4px 12px;
}
.chip:hover {
  border-color: var(--teal);
}
.sue-btn {
  margin-top: 10px;
  align-self: flex-start;
  background: var(--berry);
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 9px 16px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}
.sue-btn:hover {
  background: var(--coral);
}
</style>
